import React from 'react';
import './Logo.css'; // 确保你的CSS文件路径是正确的

interface LogoProps {
    className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
    // 使用 className 来传递额外的样式类
    return (
        <div className={`${className} logo-container`}>
            <img src="/images/logo.png" alt="Business Logo" className="logo-image" />
            <h1 className="logo-text">Business</h1>
        </div>
    );
};

export default Logo;


